import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { Provider } from "react-redux";
import { MuiThemeProvider } from "@material-ui/core";
import { ThemeProvider } from "@mui/material";
import theme from "./theme";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "@fontsource/roboto"; // Defaults to weight 400
import "@fontsource/roboto/300.css"; // Weight 300
import "@fontsource/roboto/500.css"; // Weight 500
import "@fontsource/roboto-slab";
import "@fontsource/material-icons";
import "material-icons/iconfont/material-icons.css";

import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import { ErrorBoundary } from "react-error-boundary";
import FallBack from "./components/ErrorElement/FallBack";
import { store } from "./Redux/store";
import Loader from "./components/Loader/Loader";
// import { store } from "./services/Api/store";
import reportWebVitals from "./reportWebVitals";
const App = lazy(() => import("./App"));

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  // <React.StrictMode>

  <Provider store={store}>
    {/* <ErrorBoundary fallback ={<FallBack />}> */}

    <MuiThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <App />
      </LocalizationProvider>
    </MuiThemeProvider>
    {/* </ErrorBoundary> */}
  </Provider>,

  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
